var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8425 1.27246H3.23136C2.45782 1.27246 1.71595 1.56746 1.16897 2.09256C0.621988 2.61766 0.314697 3.32985 0.314697 4.07246V13.4058C0.314697 14.1484 0.621988 14.8606 1.16897 15.3857C1.71595 15.9108 2.45782 16.2058 3.23136 16.2058H16.8425C17.616 16.2058 18.3579 15.9108 18.9049 15.3857C19.4519 14.8606 19.7591 14.1484 19.7591 13.4058V4.07246C19.7591 3.32985 19.4519 2.61766 18.9049 2.09256C18.3579 1.56746 17.616 1.27246 16.8425 1.27246V1.27246ZM16.8425 3.13913L10.523 7.31113C10.3752 7.39304 10.2076 7.43617 10.0369 7.43617C9.86626 7.43617 9.6986 7.39304 9.55081 7.31113L3.23136 3.13913H16.8425Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white",
    transform: "translate(0.0368652 0.739014)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a41818f91d8278b0ae64047262174b62.svg";
export { ForwardRef as ReactComponent };